<template>
    <div v-once>
        <ul class="bohemia-footer-list bohemia-footer-list-inline">
            <li>
                <a href="https://www.bohemia.net/cookie-policy">Cookie Policy</a>
            </li>
            <li>
                <a href="https://accounts.bistudio.com/terms-and-conditions">Terms & Conditions</a>
            </li>
            <li>
                <a href="https://www.bohemia.net/privacy-policy">Privacy Policy</a>
            </li>
            <li>
                <a href="https://support.bohemia.net">Support</a>
            </li>
        </ul>
        <div class="bohemia-footer-divider"/>
        <p>
            <small>
                © {{year}} Bohemia Interactive a.s. Bohemia Interactive® is a registered trademark of Bohemia
                Interactive a.s. All rights reserved.
            </small>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'legal',
        data : function() {
            return {
                year : new Date().getFullYear()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "./../../../assets/scss/footer/misc";
</style>
